//FUNCTION ADD TO CART IN PRODUCT-ITEM

function _addMeToCart(e, el) {
    e = e || window.event;
    e.preventDefault();
    const variantsSelect = el.parentNode.querySelector(".variant-select");
  
    console.log(el.dataset.variant_id, 42612518027462)
  
    let formData = {
      'items': [
        {
          'id': el.dataset.variant_id,
          'quantity': 1
        }
      ]
    };
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    })
  }

  document.addEventListener("limoniapps:discountninja:drawercart:refreshed", function (event) { 
    var cart = event.detail.data[0]; document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {bubbles: true}, (cart))); 
  });


//ACCESS TAG TO PRODUCT-ITEM

function compararYMostrar(tagsProductsDiv, identifierLabelDiv) {
  const outputDivId = tagsProductsDiv.getAttribute('data-output');

  // Selecciona todos los .outputDiv con el id igual al data-output
  const outputDivs = document.querySelectorAll(`.outputDiv[id="${outputDivId}"]`);

  // Selecciona todos los #outputDivPromote y filtra los que tengan la clase con el ID numérico
  const outputDivsPromote = Array.from(document.querySelectorAll('#outputDivPromote')).filter(
    el => el.classList.contains(outputDivId)
  );

  // Limpia los contenidos
  outputDivs.forEach(div => div.innerHTML = '');
  outputDivsPromote.forEach(div => div.innerHTML = '');

  // Compara los spans
  tagsProductsDiv.querySelectorAll('span').forEach(span2 => {
    const textoSpan2 = span2.textContent.trim();

    identifierLabelDiv.querySelectorAll('span').forEach(span1 => {
      const span1Id = span1.getAttribute('id');

      if (textoSpan2 === span1Id) {
        if (span1.classList.contains('PromoteTagging')) {
          outputDivsPromote.forEach(div => div.appendChild(span1.cloneNode(true)));
        } else {
          outputDivs.forEach(div => div.appendChild(span1.cloneNode(true)));
        }
      }
    });
  });
}

function ejecutarCompararYMostrar() {
  // Get all product sets on the page
  const products = document.querySelectorAll('.ProductItem');

  // Loop through each set of products and execute the compareAndShow function for each one
  products.forEach(product => {
    const tagsProductsDiv = product.querySelector('.TagsProducts');
    const identifierLabelDiv = document.getElementById('IdentifierLabel');
    compararYMostrar(tagsProductsDiv, identifierLabelDiv);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  ejecutarCompararYMostrar(); // Ejecutar la función cuando se carga el DOM
});

// Escuchar el evento personalizado y ejecutar la función cuando se dispara
document.addEventListener('theme:loading:end', function() {
  ejecutarCompararYMostrar();
});

// Llamar a la función inicialmente para que se ejecute cuando se carga la página
ejecutarCompararYMostrar();

function procesarElementos() {
  // Obtén todos los elementos con la clase "Grid__Cell"
  const gridCells = document.querySelectorAll(".ProductItem");

  // Recorre cada elemento con la clase "Grid__Cell"
  gridCells.forEach((gridCell) => {
    // Busca el span con el id "novedad" dentro de este elemento
    const novedadSpan = gridCell.querySelector("#novedad__novedad");

    // Busca el span con la clase "LabelSoon" dentro de este elemento
    const labelSoonSpan = gridCell.querySelector(".LabelSoon");

    const novedadPermanenteSpan = gridCell.querySelector("#novedad__permanente");

    // Verifica si ambos spans existen en este elemento
    if (novedadSpan && (labelSoonSpan || novedadPermanenteSpan)) {
      // Si el span con la clase "LabelSoon" o "novedad__permanente" está presente, elimina el span con el id "novedad__Novedad"
      novedadSpan.parentNode.removeChild(novedadSpan);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  procesarElementos(); // Ejecutar la función cuando se carga el DOM
});

// Escuchar el evento personalizado y ejecutar la función cuando se dispara
document.addEventListener('theme:loading:end', function() {
  procesarElementos();
});

// Llama a la función para procesar los elementos
procesarElementos();



//BREADCRUMB HISTORY USING SESSIONSTORAGE

function setSessionStorage(name, value) {
  sessionStorage.setItem(name, value);
}

function getSessionStorage(name) {
  return sessionStorage.getItem(name);
}


// ARROWS UI SHOWING

document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons with the class "Collapsible__Button"
  const collapsibleButtons = document.querySelectorAll(".Collapsible__Button");

  // Attach a click event listener to each collapsible button
  collapsibleButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      // Find the arrow icons within the clicked button
      const arrowRightIcon = event.currentTarget.querySelector(".ArrowShowRight");
      const arrowBottomIcon = event.currentTarget.querySelector(".ArrowShowBottom");

      // Toggle the "selected" class for both arrow icons
      arrowRightIcon.classList.toggle("selected");
      arrowBottomIcon.classList.toggle("selected");
    });
  });
});



//OBSERVER MENU ICONS IN STICKY MENU


document.addEventListener("DOMContentLoaded", function () {
  const button1 = document.querySelector('.IDShowing');
  const button2 = document.querySelector('.HiddenMenuStick');
  const sidebarStickyMenu = document.querySelector('#sidebar-sticky-menu');

  // Add event listeners to the buttons
  button1.addEventListener('click', toggleButtons);
  button2.addEventListener('click', toggleButtons);

  // Configure MutationObserver to watch for changes in the aria-hidden attribute of the sidebar menu
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.attributeName === 'aria-hidden') {
        toggleButtons();
        break;
      }
    }
  });

  // Observe changes in the aria-hidden attribute of the sidebar menu
  observer.observe(sidebarStickyMenu, { attributes: true });

  function toggleButtons() {
    const isMenuHidden = sidebarStickyMenu.getAttribute('aria-hidden') === 'true';
    if (isMenuHidden) {
      button1.classList.remove('HiddenMenuStick');
      button2.classList.add('HiddenMenuStick');
    } else {
      button1.classList.add('HiddenMenuStick');
      button2.classList.remove('HiddenMenuStick');
    }
  }
});


    const announcementSlides = document.querySelectorAll('.announcement_slide_wrapper');
    if(announcementSlides){
      setTimeout(() => {
        announcementSlides.forEach(slide => {slide.style.opacity = null; slide.style.height = "100%";  slide.style.minHeight = "100%"; slide.style.marginTop = null });
      }, 100)
    }



/* add to cart button show/hide when out of stock on variant change */

function variantClickFn(btn) {
  const isAvailableOption = btn.getAttribute("data-available-option");
  const quantityBtnNew = document.getElementById(
    "ProductForm__QuantitySelector_new"
  );
  const atcBtnNew = document.getElementById("ProductForm__BuyButtons_new");
  const atcTraditional = document.getElementById("ProductForm__AddToCart_btn");

  if (isAvailableOption === "true") {
    quantityBtnNew.style.display = "inline-block";
    atcBtnNew.style.display = "inline-block";
    atcTraditional.setAttribute("data-action", "add-to-cart");
    atcTraditional.removeAttribute("disabled");
  } else {
    quantityBtnNew.style.display = "none";
    atcBtnNew.style.display = "none";
  }

  setTimeout(updatePriceComponent, 100);
  appendElements();
}

function updatePriceComponent() {
  const priceComponent = document.querySelector(".priceComponentPdp");
  const priceComponent2 = document.querySelector(".priceComponentPdp2");
  priceComponent2.innerHTML = priceComponent.innerHTML;
}

function appendElements() {
  const productActionsBtns = document.getElementById("product_actions_btns");
  const quantitySelector = document.getElementById(
    "ProductForm__QuantitySelector_new"
  );
  const buyButtons = document.getElementById("ProductForm__BuyButtons_new");
  const buyToCheckoutBtn = document.getElementById("buy_to_checkout_btn");
  const BIS_triggerBtn = document.getElementById("BIS_trigger");

  productActionsBtns.appendChild(quantitySelector);
  productActionsBtns.appendChild(buyButtons);
  productActionsBtns.appendChild(buyToCheckoutBtn);
  productActionsBtns.appendChild(BIS_triggerBtn);
}

document.addEventListener("DOMContentLoaded", () => {
  // const checkedColorSwatch = document.querySelector(
  //   ".ColorSwatch__Radio:checked"
  // );
  // variantClickFn(checkedColorSwatch);
  appendElements();
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(()=> {
  const oxiText = document.querySelector('.social_login.google')
  }, 1000)
});


